import React, { FC, ReactNode, useContext } from 'react'
import { useConnectParams } from 'src/connect/useParams'
import { ClientSettingContext } from './Context'
import { ClientSetting, clientSettings, getClientSettingByCookieLoginClientId } from './settings'

/**
 * @public
 * 将来 pharmacist-app が複数 client 対応する際の Storybook テーマ切替用に予約。
 */
export const StaticClientSettingProvider: FC<{ client: ClientSetting; children: ReactNode }> = ({
  client,
  children,
}) => {
  return <ClientSettingContext.Provider value={client}>{children}</ClientSettingContext.Provider>
}

export const ClientSettingFromConnectParamsProvider = ({ children }: { children: ReactNode }) => {
  const params = useConnectParams()
  if (!params.paramsReady) {
    return null
  }

  const clientId = params.params.cookieLogin?.clientId
  const setting =
    (clientId && getClientSettingByCookieLoginClientId(clientId)) || clientSettings.default

  return <ClientSettingContext.Provider value={setting}>{children}</ClientSettingContext.Provider>
}

export const useClientSetting = () => useContext(ClientSettingContext)
